"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutoForm = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const schema_1 = require("@orion-js/schema");
const debounce_1 = tslib_1.__importDefault(require("lodash/debounce"));
const WithParams_1 = tslib_1.__importDefault(require("./WithParams"));
const Form_1 = tslib_1.__importDefault(require("./Form"));
const Fields_1 = tslib_1.__importDefault(require("./Fields"));
const WithMutation_1 = tslib_1.__importDefault(require("./WithMutation"));
const getFragment_1 = tslib_1.__importDefault(require("./getFragment"));
const options = {
    getField: () => {
        throw new Error('You must pass a getField function');
    },
    onError: error => alert(error.message),
    getErrorText: code => code,
    loading: null,
    getDefaultLabel: () => 'This field'
};
class AutoForm extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.form = null;
        this.debouncedSubmit = null;
        this.submit = () => {
            return this.form.submit();
        };
        this.onChange = newDoc => {
            if (this.props.onChange) {
                this.props.onChange(newDoc);
            }
            if (this.props.autoSave) {
                this.debouncedSubmit();
            }
        };
        this.debouncedSubmit = (0, debounce_1.default)(this.submit, props.autoSaveDebounceTime);
    }
    renderChildren({ params }) {
        if (typeof this.props.children === 'function') {
            return this.props.children({
                params,
                omit: this.props.omit,
                only: this.props.only
            });
        }
        return this.props.children;
    }
    getFragment({ name, result, basicResultQuery, params }) {
        if (this.props.fragment) {
            return this.props.fragment;
        }
        return (0, getFragment_1.default)({ name, result, basicResultQuery, params });
    }
    render() {
        const passedClient = options.getClient ? options.getClient() : undefined;
        const client = this.props.client ? this.props.client : passedClient;
        return (react_1.default.createElement(WithParams_1.default, { name: this.props.mutation, loading: options.loading, client: client }, ({ name, result, basicResultQuery, params }) => (react_1.default.createElement(WithMutation_1.default, { refetchQueries: this.props.refetchQueries, params: params, fragment: this.getFragment({
                name,
                result,
                basicResultQuery,
                params
            }), mutation: this.props.mutation }, (mutate) => (react_1.default.createElement(Form_1.default, { setRef: form => (this.form = form), buttonRef: this.props.buttonRef, doc: this.props.doc, mutate: mutate, useFormTag: this.props.useFormTag, className: this.props.className, onChange: this.onChange, params: params, getDefaultLabel: this.props.getDefaultLabel, schema: this.props.schema || params, onSuccess: this.props.onSuccess, onError: this.props.onError, getErrorFieldLabel: this.props.getErrorFieldLabel, onValidationError: this.props.onValidationError, clean: this.props.clean, getErrorText: this.props.getErrorText, validate: this.props.validate }, this.renderChildren({ params: this.props.schema || params })))))));
    }
}
exports.AutoForm = AutoForm;
AutoForm.defaultProps = {
    children: props => react_1.default.createElement(Fields_1.default, { getField: options.getField, ...props }),
    clean: schema_1.clean,
    validate: schema_1.getValidationErrors,
    omit: [],
    only: [],
    onSuccess: () => { },
    onValidationError: () => { },
    onError: error => options.onError(error),
    getErrorText: (code, field) => options.getErrorText(code, field),
    getDefaultLabel: () => options.getDefaultLabel(),
    autoSaveDebounceTime: 500
};
function createAutoForm(passedOptions) {
    for (const key in passedOptions) {
        options[key] = passedOptions[key];
    }
    return AutoForm;
}
exports.default = createAutoForm;
//# sourceMappingURL=index.js.map